import React from 'react'
import { CheckIcon } from '../../img/images'
import { withComponentLabel } from '../../utils/debug'

function Drawer({
  display,
  action,
  onChange,
  placeholder,
  handleButtonClick,
  addIcon,
  inputName,
}) {
  const displayClass = display ? 'w-full' : 'w-0'
  const borderClass = display ? 'border-2' : 'border-0'
  const checkButtonVisible = display ? 'w-20' : 'w-0'

  const checkIcon = (
    <CheckIcon
      stroke="stroke-white"
      width="10"
      height="10"
    />
  )

  return (
    <>
      {/* button */}
      <div className="flex p-2 h-auto text-5xl justify-end md:text-7xl">
        <form
          className="flex flex-grow"
          onSubmit={action}
          id="new-store-form"
        >
          <input
            type="text"
            className={`${displayClass} transition-all duration-150 ease-in-out overflow-hidden text-center font-bold text-2xl ${borderClass} border-gray-400 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-300 focus:border-transparent`}
            name={`${inputName ? inputName : 'name'}`}
            placeholder={placeholder}
            onChange={onChange}
          />
        </form>
        <div
          className={`mx-4 flex flex-shrink-0 overflow-hidden transition-all duration-150 ease-in-out ${checkButtonVisible}`}
        >
          <button
            className={`flex justify-center items-center w-full rounded-3xl bg-orange-500`}
            type="submit"
            form="new-store-form"
          >
            <CheckIcon
              strokeWidth="3"
              strokeColor="white"
              width="10"
              height="10"
            />
          </button>
        </div>
        <button
          className={`p-2 transition-all duration-150 ease-in-out ${
            display ? 'rotate-45' : ''
          }`}
          onClick={handleButtonClick}
        >
          {addIcon}
        </button>
      </div>
      {/* drawer */}
      {/* <div
        className={`${displayClass} box-border flex flex-col gap-4 leading-snug bg-gray-50 border-t-2 m-5 border-gray-300 shadow-inner shadow-gray-200`}
      >
        <form className={`${displayClass}`} onSubmit={action}>
          <input
            name={`${inputName ? inputName : 'name'}`}
            type='text'
            className={`${displayClass} box-border w-full text-center font-bold text-2xl border-2 border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gray-300 focus:border-transparent`}
            placeholder={placeholder}
            onChange={onChange}
          />
        </form>
      </div> */}
    </>
  )
}

export default withComponentLabel(Drawer, '📥 Drawer')
